import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CatalogueGame, CatalogueTemplate } from 'src/app/models/bot/catalogue';
import { BotResourceService } from 'src/app/services/bot-resource.service';

export type EditCatalogueTemplateDialogData = {
  template: CatalogueTemplate;
};

@Component({
  selector: 'app-edit-catalogue-template-dialog',
  templateUrl: './edit-catalogue-template-dialog.component.html',
  styleUrls: ['./edit-catalogue-template-dialog.component.css'],
})
export class EditCatalogueTemplateDialogComponent implements OnInit {
  form: FormGroup;
  games: CatalogueGame[] = [];
  saving = false;

  constructor(
    private fb: FormBuilder,
    private botService: BotResourceService,
    private dialogRef: MatDialogRef<EditCatalogueTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditCatalogueTemplateDialogData
  ) {
    const template = data.template;
    this.form = this.fb.group({
      title: [template.title, [Validators.required, Validators.minLength(2), Validators.maxLength(25)]],
      description: [
        template.description,
        [Validators.required, Validators.minLength(10), Validators.maxLength(1024)],
      ],
      notes: [template.notes || '', [Validators.maxLength(1024)]],
      game_id: [template.game_id, [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.botService.listCatalogueGames().subscribe({
      next: (games) => {
        this.games = games;
        if (
          this.data.template.game_id != null &&
          !games.some((game) => game.id === this.data.template.game_id)
        ) {
          this.form.patchValue({ game_id: null });
        }
      },
    });
  }

  save(): void {
    if (this.form.invalid || this.saving) {
      this.form.markAllAsTouched();
      return;
    }
    this.saving = true;
    const value = this.form.value;
    this.botService
      .updateCatalogueTemplate(this.data.template.id, {
        title: value.title.trim(),
        description: value.description.trim(),
        notes: (value.notes || '').trim(),
        game_id: Number(value.game_id),
      })
      .subscribe({
        next: (updated) => {
          this.saving = false;
          this.dialogRef.close(updated);
        },
        error: () => {
          this.saving = false;
        },
      });
  }
}
